import { ErrorScreen, NotFoundScreen } from '@/components/shared/ErrorScreen'
import { createRouter } from '@tanstack/react-router'
import { Route as rootRoute } from './routes/__root'
import { Route as AcceptInviteRoute } from './routes/accept-invite'
import { Route as AccountingLedgerRoute } from './routes/app/accounting/accounts.$code.index'
import { Route as AccountingBalanceSheetRoute } from './routes/app/accounting/balance-sheet'
import { Route as AccountingEntryEditRoute } from './routes/app/accounting/entries.$entryId.edit'
import { Route as AccountingEntryDetailRoute } from './routes/app/accounting/entries.$entryId.index'
import { Route as AccountingEntriesListRoute } from './routes/app/accounting/entries.index'
import { Route as AccountingEntryNewRoute } from './routes/app/accounting/entries.new'
import { Route as AccountingIncomeStatementRoute } from './routes/app/accounting/income-statement'
import { Route as AccountingDashboardRoute } from './routes/app/accounting/index'
import { Route as AccountingReconciliationDetailRoute } from './routes/app/accounting/reconciliation.$statementId.index'
import { Route as AccountingReconciliationRoute } from './routes/app/accounting/reconciliation.index'
import { Route as AccountingTrialBalanceRoute } from './routes/app/accounting/trial-balance'
import { Route as AccountingVATDetailRoute } from './routes/app/accounting/vat.$declarationId.index'
import { Route as AccountingVATRoute } from './routes/app/accounting/vat.index'
import { Route as AdminAuditRoute } from './routes/app/admin/audit'
import { Route as AdminDelegationsRoute } from './routes/app/admin/delegations'
import { Route as AdminRoleEditorRoute } from './routes/app/admin/roles/$roleId.index'
import { Route as AdminRolesListRoute } from './routes/app/admin/roles/index'
import { Route as AdminSettingsRoute } from './routes/app/admin/settings'
import { Route as AdminUserDetailRoute } from './routes/app/admin/users/$userId.index'
import { Route as AdminUsersListRoute } from './routes/app/admin/users/index'
import { Route as AdvanceDetailRoute } from './routes/app/advances/$advanceId.index'
import { Route as AdvancesListRoute } from './routes/app/advances/index'
import { Route as CmsArticleDetailRoute } from './routes/app/cms/articles.$articleId'
import { Route as CmsArticlesListRoute } from './routes/app/cms/articles.index'
import { Route as CmsArticleNewRoute } from './routes/app/cms/articles.new'
import { Route as CmsContentRoute } from './routes/app/cms/content'
import { Route as CmsDashboardRoute } from './routes/app/cms/index'
import { Route as CmsLayoutRoute } from './routes/app/cms/layout'
import { Route as CRMActivitiesRoute } from './routes/app/crm/activities'
import { Route as CRMChurnRiskRoute } from './routes/app/crm/churn-risk'
import { Route as CRMCustomerDetailRoute } from './routes/app/crm/customers.$customerId.index'
import { Route as CRMCustomersRoute } from './routes/app/crm/customers.index'
import { Route as CRMForecastRoute } from './routes/app/crm/forecast'
import { Route as CRMDashboardRoute } from './routes/app/crm/index'
import { Route as CRMLeadsRoute } from './routes/app/crm/leads.index'
import { Route as CRMPipelineRoute } from './routes/app/crm/pipeline'
import { Route as CRMQuoteRequestsRoute } from './routes/app/crm/quote-requests.index'
import { Route as CRMSettingsRoute } from './routes/app/crm/settings'
import { Route as CustomerEditRoute } from './routes/app/customers/$customerId.edit'
import { Route as CustomerDetailRoute } from './routes/app/customers/$customerId.index'
import { Route as CustomersListRoute } from './routes/app/customers/index'
import { Route as CustomerNewRoute } from './routes/app/customers/new'
import { Route as CustomsCircuitRoute } from './routes/app/customs/circuit'
import { Route as CustomsDeclarationRoute } from './routes/app/customs/declaration'
import { Route as CustomsDossiersRoute } from './routes/app/customs/dossiers'
import { Route as CustomsDashboardRoute } from './routes/app/customs/index'
import { Route as CustomsReportsRoute } from './routes/app/customs/reports'
import { Route as CustomsSimulationRoute } from './routes/app/customs/simulation'
import { Route as CustomsSuspensiveRoute } from './routes/app/customs/suspensive'
import { Route as DashboardRoute } from './routes/app/dashboard'
import { Route as ExpensesCategoriesRoute } from './routes/app/expenses/categories.index'
import { Route as ExpensesClaimDetailRoute } from './routes/app/expenses/claims.$claimId.index'
import { Route as ExpensesClaimsListRoute } from './routes/app/expenses/claims.index'
import { Route as ExpensesClaimNewRoute } from './routes/app/expenses/claims.new'
import { Route as ExpensesDashboardRoute } from './routes/app/expenses/index'
import { Route as FinanceInvoiceDetailRoute } from './routes/app/finance/$invoiceId.index'
import { Route as FinanceARRoute } from './routes/app/finance/ar'
import { Route as FinanceDashboardRoute } from './routes/app/finance/index'
import { Route as FinanceInvoicesRoute } from './routes/app/finance/invoices.index'
import { Route as FinanceInvoiceNewRoute } from './routes/app/finance/invoices.new'
import { Route as FinancePaymentsListRoute } from './routes/app/finance/payments.index'
import { Route as FinancePaymentNewRoute } from './routes/app/finance/payments.new'
import { Route as FinanceVendorBillDetailRoute } from './routes/app/finance/vendor-bills.$billId.index'
import { Route as FinanceVendorBillsRoute } from './routes/app/finance/vendor-bills.index'
import { Route as FinanceVendorBillNewRoute } from './routes/app/finance/vendor-bills.new'
import { Route as FinanceVendorPaymentDetailRoute } from './routes/app/finance/vendor-payments.$paymentId.index'
import { Route as FinanceVendorPaymentsRoute } from './routes/app/finance/vendor-payments.index'
import { Route as FreightAirRoute } from './routes/app/freight/air'
import { Route as FreightCompaniesRoute } from './routes/app/freight/companies'
import { Route as FreightCompanyRoute } from './routes/app/freight/companies/$companyId'
import { Route as FreightCompanyNewRoute } from './routes/app/freight/companies/new'
import { Route as FreightFileRoute } from './routes/app/freight/dossiers/$fileId'
import { Route as FreightDeskRoute } from './routes/app/freight/index'
import { Route as FreightGroupagesRoute } from './routes/app/freight/groupages'
import { Route as FreightGroupageRoute } from './routes/app/freight/groupages/$consolidationId'
import { Route as FreightRoadRoute } from './routes/app/freight/road'
import { Route as AppHomeRoute } from './routes/app/home'
import { Route as HRAnalyticsRoute } from './routes/app/hr/analytics'
import { Route as HRAttendanceManagerRoute } from './routes/app/hr/attendance/index'
import { Route as HRContractDetailRoute } from './routes/app/hr/contracts/$contractId.index'
import { Route as HRContractsListRoute } from './routes/app/hr/contracts/index'
import { Route as HRContractNewRoute } from './routes/app/hr/contracts/new'
import { Route as HRDocumentsRoute } from './routes/app/hr/documents'
import { Route as HREmployeeEditRoute } from './routes/app/hr/employees/$employeeId.edit'
import { Route as HREmployeeDetailRoute } from './routes/app/hr/employees/$employeeId.index'
import { Route as HREmployeesListRoute } from './routes/app/hr/employees/index'
import { Route as HREmployeeNewRoute } from './routes/app/hr/employees/new'
import { Route as HRDashboardRoute } from './routes/app/hr/index'
import { Route as HRLeaveDetailRoute } from './routes/app/hr/leaves/$leaveId.index'
import { Route as HRLeavesCalendarRoute } from './routes/app/hr/leaves/calendar'
import { Route as HRLeavesListRoute } from './routes/app/hr/leaves/index'
import { Route as HRLeaveNewRoute } from './routes/app/hr/leaves/new'
import { Route as HROrgChartRoute } from './routes/app/hr/org-chart'
import { Route as AppLayoutRoute } from './routes/app/layout'
import { Route as LearnArticleRoute } from './routes/app/learn/articles.$slug'
import { Route as LearnCollectionRoute } from './routes/app/learn/collections.$slug'
import { Route as LearnGlossaryRoute } from './routes/app/learn/glossary'
import { Route as LearnHomeRoute } from './routes/app/learn/index'
import { Route as MyAdvanceDetailRoute } from './routes/app/my/advances/$advanceId.index'
import { Route as MyAdvancesListRoute } from './routes/app/my/advances/index'
import { Route as MyAdvanceNewRoute } from './routes/app/my/advances/new'
import { Route as MyAttendanceRoute } from './routes/app/my/attendance/index'
import { Route as MyDocumentsRoute } from './routes/app/my/documents'
import { Route as MyDashboardRoute } from './routes/app/my/index'
import { Route as MyLeaveDetailRoute } from './routes/app/my/leaves/$leaveId.index'
import { Route as MyLeavesListRoute } from './routes/app/my/leaves/index'
import { Route as MyLeaveNewRoute } from './routes/app/my/leaves/new'
import { Route as MyPayslipDetailRoute } from './routes/app/my/payslips/$payslipId.index'
import { Route as MyPayslipsListRoute } from './routes/app/my/payslips/index'
import { Route as MyProfileRoute } from './routes/app/my/profile'
import { Route as MySettingsRoute } from './routes/app/my/settings'
import { Route as PayrollAdvancesRoute } from './routes/app/payroll/advances.index'
import { Route as PayrollAnalyticsRoute } from './routes/app/payroll/analytics'
import { Route as PayrollDeclarationsRoute } from './routes/app/payroll/declarations.index'
import { Route as PayrollDashboardRoute } from './routes/app/payroll/index'
import { Route as PayslipDetailRoute } from './routes/app/payroll/payslips.$payslipId.index'
import { Route as PayslipsListRoute } from './routes/app/payroll/payslips.index'
import { Route as PayrollPeriodDetailRoute } from './routes/app/payroll/periods.$periodId.index'
import { Route as PayrollPeriodsListRoute } from './routes/app/payroll/periods.index'
import { Route as SettingsAccountingRoute } from './routes/app/settings/accounting'
import { Route as SettingsBrandingRoute } from './routes/app/settings/branding'
import { Route as SettingsChartOfAccountsRoute } from './routes/app/settings/chart-of-accounts'
import { Route as SettingsCopilotRoute } from './routes/app/settings/copilot'
import { Route as SettingsCustomsReferentialRoute } from './routes/app/settings/customs-referential'
import { Route as SettingsDocumentsRoute } from './routes/app/settings/documents'
import { Route as SettingsDocumentsTermsRoute } from './routes/app/settings/documents.terms'
import { Route as SettingsEmailRoute } from './routes/app/settings/email'
import { Route as SettingsHRRoute } from './routes/app/settings/hr'
import { Route as SettingsIndexRoute } from './routes/app/settings/index'
import { Route as SettingsLayoutRoute } from './routes/app/settings/layout'
import { Route as SettingsLearnRoute } from './routes/app/settings/learn'
import { Route as SettingsOrgRoute } from './routes/app/settings/organization'
import { Route as SettingsPayrollRoute } from './routes/app/settings/payroll'
import { Route as SettingsPreferencesRoute } from './routes/app/settings/preferences'
import { Route as SettingsProfileRoute } from './routes/app/settings/profile'
import { Route as SettingsSecurityRoute } from './routes/app/settings/security'
import { Route as SettingsSubscriptionRoute } from './routes/app/settings/subscription'
import { Route as TariffsRoute } from './routes/app/settings/tariffs'
import { Route as SettingsUsersRoute } from './routes/app/settings/users/index'
import { Route as SupplierDetailRoute } from './routes/app/suppliers/$supplierId.index'
import { Route as SuppliersDashboardRoute } from './routes/app/suppliers/dashboard'
import { Route as SuppliersListRoute } from './routes/app/suppliers/index'
import { Route as SuspendedRoute } from './routes/app/suspended'
import { Route as WarehouseBillingRoute } from './routes/app/warehouse/billing'
import { Route as WarehouseControlRoute } from './routes/app/warehouse/control'
import { Route as WarehouseHandoverRoute } from './routes/app/warehouse/handover'
import { Route as WarehouseBoardRoute } from './routes/app/warehouse/index'
import { Route as WarehouseLeasesRoute } from './routes/app/warehouse/leases'
import { Route as WarehousePutawayRoute } from './routes/app/warehouse/putaway'
import { Route as WarehouseReceptionRoute } from './routes/app/warehouse/reception'
import { Route as WarehouseSitesRoute } from './routes/app/warehouse/sites'
import { Route as ForgotRoute } from './routes/auth/forgot'
import { Route as AuthLayoutRoute } from './routes/auth/layout'
import { Route as LoginRoute } from './routes/auth/login'
import { Route as ChangePasswordRoute } from './routes/change-password'
import { Route as HealthCheckRoute } from './routes/health-check'
import { Route as IndexRoute } from './routes/index'
import { Route as ResetPasswordRoute } from './routes/reset-password'

const authTree = AuthLayoutRoute.addChildren([LoginRoute, ForgotRoute])
const cmsTree = CmsLayoutRoute.addChildren([
  CmsDashboardRoute,
  CmsArticlesListRoute,
  CmsArticleNewRoute,
  CmsArticleDetailRoute,
  CmsContentRoute,
])
const settingsTree = SettingsLayoutRoute.addChildren([
  SettingsIndexRoute,
  SettingsProfileRoute,
  SettingsSecurityRoute,
  SettingsPreferencesRoute,
  SettingsOrgRoute,
  SettingsUsersRoute,
  TariffsRoute,
  SettingsCustomsReferentialRoute,
  SettingsCopilotRoute,
  SettingsDocumentsRoute,
  SettingsDocumentsTermsRoute,
  SettingsEmailRoute,
  SettingsChartOfAccountsRoute,
  SettingsAccountingRoute,
  SettingsPayrollRoute,
  SettingsHRRoute,
  SettingsBrandingRoute,
  SettingsLearnRoute,
  SettingsSubscriptionRoute,
])
const appTree = AppLayoutRoute.addChildren([
  AppHomeRoute,
  AdminUsersListRoute,
  AdminUserDetailRoute,
  AdminRolesListRoute,
  AdminSettingsRoute,
  AdminRoleEditorRoute,
  AdminDelegationsRoute,
  AdminAuditRoute,
  DashboardRoute,
  CustomersListRoute,
  CustomerNewRoute,
  CustomerDetailRoute,
  CustomerEditRoute,
  CustomsDashboardRoute,
  CustomsSimulationRoute,
  CustomsDeclarationRoute,
  CustomsDossiersRoute,
  CustomsCircuitRoute,
  CustomsSuspensiveRoute,
  CustomsReportsRoute,
  FreightDeskRoute,
  FreightGroupagesRoute,
  FreightGroupageRoute,
  FreightAirRoute,
  FreightRoadRoute,
  FreightCompaniesRoute,
  FreightCompanyNewRoute,
  FreightCompanyRoute,
  FreightFileRoute,
  WarehouseBoardRoute,
  WarehouseReceptionRoute,
  WarehousePutawayRoute,
  WarehouseHandoverRoute,
  WarehouseControlRoute,
  WarehouseBillingRoute,
  WarehouseLeasesRoute,
  WarehouseSitesRoute,
  CRMDashboardRoute,
  CRMCustomersRoute,
  CRMCustomerDetailRoute,
  CRMChurnRiskRoute,
  CRMPipelineRoute,
  CRMLeadsRoute,
  CRMQuoteRequestsRoute,
  CRMActivitiesRoute,
  CRMForecastRoute,
  CRMSettingsRoute,
  FinanceDashboardRoute,
  FinanceInvoicesRoute,
  FinanceInvoiceNewRoute,
  FinanceInvoiceDetailRoute,
  FinancePaymentsListRoute,
  FinancePaymentNewRoute,
  FinanceARRoute,
  FinanceVendorBillsRoute,
  FinanceVendorBillNewRoute,
  FinanceVendorBillDetailRoute,
  FinanceVendorPaymentsRoute,
  FinanceVendorPaymentDetailRoute,
  SuppliersDashboardRoute,
  SuppliersListRoute,
  SupplierDetailRoute,
  LearnHomeRoute,
  LearnArticleRoute,
  LearnCollectionRoute,
  LearnGlossaryRoute,
  AccountingDashboardRoute,
  AccountingTrialBalanceRoute,
  AccountingIncomeStatementRoute,
  AccountingBalanceSheetRoute,
  AccountingLedgerRoute,
  AccountingEntriesListRoute,
  AccountingEntryNewRoute,
  AccountingEntryDetailRoute,
  AccountingEntryEditRoute,
  AccountingVATRoute,
  AccountingVATDetailRoute,
  AccountingReconciliationRoute,
  AccountingReconciliationDetailRoute,
  ExpensesDashboardRoute,
  ExpensesClaimsListRoute,
  ExpensesClaimNewRoute,
  ExpensesClaimDetailRoute,
  ExpensesCategoriesRoute,
  HRDashboardRoute,
  HRAnalyticsRoute,
  HRAttendanceManagerRoute,
  HREmployeesListRoute,
  HREmployeeNewRoute,
  HREmployeeDetailRoute,
  HREmployeeEditRoute,
  HRContractsListRoute,
  HRContractNewRoute,
  HRContractDetailRoute,
  HRLeavesListRoute,
  HRLeaveNewRoute,
  HRLeaveDetailRoute,
  HRLeavesCalendarRoute,
  HRDocumentsRoute,
  HROrgChartRoute,
  PayrollDashboardRoute,
  PayrollPeriodsListRoute,
  PayrollPeriodDetailRoute,
  PayslipsListRoute,
  PayslipDetailRoute,
  PayrollAnalyticsRoute,
  PayrollDeclarationsRoute,
  PayrollAdvancesRoute,
  MyDashboardRoute,
  MyProfileRoute,
  MyDocumentsRoute,
  MyLeavesListRoute,
  MyLeaveDetailRoute,
  MyLeaveNewRoute,
  MyAttendanceRoute,
  MyAdvancesListRoute,
  MyAdvanceNewRoute,
  MyAdvanceDetailRoute,
  AdvancesListRoute,
  AdvanceDetailRoute,
  MyPayslipsListRoute,
  MyPayslipDetailRoute,
  MySettingsRoute,
  SuspendedRoute,
  settingsTree,
  cmsTree,
])

const routeTree = rootRoute.addChildren([
  IndexRoute,
  HealthCheckRoute,
  AcceptInviteRoute,
  ChangePasswordRoute,
  ResetPasswordRoute,
  authTree,
  appTree,
])

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultErrorComponent: ErrorScreen,
  defaultNotFoundComponent: NotFoundScreen,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
